import React, { useState, useEffect } from 'react';
import {
    Button,
    TextField,
    MenuItem,
    Select,
    IconButton,
    Autocomplete
} from '@mui/material';
import deleteIcon from '@/assets/preemie-nutrition/delete.svg';
import editIcon from '@/assets/preemie-nutrition/edit.svg';
import { isNutrientKey } from './nutritionConfigKeys';

const DeleteIconSvg = () => (
    <img src={deleteIcon} alt="delete" style={{ width: '20px', height: '20px' }} />
);

const EditIconSvg = () => (
    <img src={editIcon} alt="edit" style={{ width: '20px', height: '20px' }} />
);

const DocumentIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginLeft: '10px' }}>
        <path d="M9 21H15C19 21 21 19 21 15V9C21 5 19 3 15 3H9C5 3 3 5 3 9V15C3 19 5 21 9 21Z" stroke="#103C6E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9 10H15" stroke="#103C6E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9 14H13" stroke="#103C6E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const SettingsIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="#103C6E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M19.4 15C19.2669 15.3016 19.2272 15.6362 19.286 15.9606C19.3448 16.285 19.4995 16.5843 19.73 16.82L19.79 16.88C19.976 17.0657 20.1235 17.2863 20.2241 17.5291C20.3248 17.7719 20.3766 18.0322 20.3766 18.295C20.3766 18.5578 20.3248 18.8181 20.2241 19.0609C20.1235 19.3037 19.976 19.5243 19.79 19.71C19.6043 19.896 19.3837 20.0435 19.1409 20.1441C18.8981 20.2448 18.6378 20.2966 18.375 20.2966C18.1122 20.2966 17.8519 20.2448 17.6091 20.1441C17.3663 20.0435 17.1457 19.896 16.96 19.71L16.9 19.65C16.6643 19.4195 16.365 19.2648 16.0406 19.206C15.7162 19.1472 15.3816 19.1869 15.08 19.32C14.7842 19.4468 14.532 19.6572 14.3543 19.9255C14.1766 20.1938 14.0813 20.5082 14.08 20.83V21C14.08 21.5304 13.8693 22.0391 13.4942 22.4142C13.1191 22.7893 12.6104 23 12.08 23C11.5496 23 11.0409 22.7893 10.6658 22.4142C10.2907 22.0391 10.08 21.5304 10.08 21V20.91C10.0723 20.579 9.96512 20.258 9.77251 19.9887C9.5799 19.7194 9.31074 19.5143 9 19.4C8.69838 19.2669 8.36381 19.2272 8.03941 19.286C7.71502 19.3448 7.41568 19.4995 7.18 19.73L7.12 19.79C6.93425 19.976 6.71368 20.1235 6.47088 20.2241C6.22808 20.3248 5.96783 20.3766 5.705 20.3766C5.44217 20.3766 5.18192 20.3248 4.93912 20.2241C4.69632 20.1235 4.47575 19.976 4.29 19.79C4.10405 19.6043 3.95653 19.3837 3.85588 19.1409C3.75523 18.8981 3.70343 18.6378 3.70343 18.375C3.70343 18.1122 3.75523 17.8519 3.85588 17.6091C3.95653 17.3663 4.10405 17.1457 4.29 16.96L4.35 16.9C4.58054 16.6643 4.73519 16.365 4.794 16.0406C4.85282 15.7162 4.81312 15.3816 4.68 15.08C4.55324 14.7842 4.34276 14.532 4.07447 14.3543C3.80618 14.1766 3.49179 14.0813 3.17 14.08H3C2.46957 14.08 1.96086 13.8693 1.58579 13.4942C1.21071 13.1191 1 12.6104 1 12.08C1 11.5496 1.21071 11.0409 1.58579 10.6658C1.96086 10.2907 2.46957 10.08 3 10.08H3.09C3.42099 10.0723 3.742 9.96512 4.0113 9.77251C4.28059 9.5799 4.48572 9.31074 4.6 9C4.73312 8.69838 4.77282 8.36381 4.714 8.03941C4.65519 7.71502 4.50054 7.41568 4.27 7.18L4.21 7.12C4.02405 6.93425 3.87653 6.71368 3.77588 6.47088C3.67523 6.22808 3.62343 5.96783 3.62343 5.705C3.62343 5.44217 3.67523 5.18192 3.77588 4.93912C3.87653 4.69632 4.02405 4.47575 4.21 4.29C4.39575 4.10405 4.61632 3.95653 4.85912 3.85588C5.10192 3.75523 5.36217 3.70343 5.625 3.70343C5.88783 3.70343 6.14808 3.75523 6.39088 3.85588C6.63368 3.95653 6.85425 4.10405 7.04 4.29L7.1 4.35C7.33568 4.58054 7.63502 4.73519 7.95941 4.794C8.28381 4.85282 8.61838 4.81312 8.92 4.68H9C9.29577 4.55324 9.54802 4.34276 9.72569 4.07447C9.90337 3.80618 9.99872 3.49179 10 3.17V3C10 2.46957 10.2107 1.96086 10.5858 1.58579C10.9609 1.21071 11.4696 1 12 1C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V3.09C14.0013 3.41179 14.0966 3.72618 14.2743 3.99447C14.452 4.26276 14.7042 4.47324 15 4.6C15.3016 4.73312 15.6362 4.77282 15.9606 4.714C16.285 4.65519 16.5843 4.50054 16.82 4.27L16.88 4.21C17.0657 4.02405 17.2863 3.87653 17.5291 3.77588C17.7719 3.67523 18.0322 3.62343 18.295 3.62343C18.5578 3.62343 18.8181 3.67523 19.0609 3.77588C19.3037 3.87653 19.5243 4.02405 19.71 4.21C19.896 4.39575 20.0435 4.61632 20.1441 4.85912C20.2448 5.10192 20.2966 5.36217 20.2966 5.625C20.2966 5.88783 20.2448 6.14808 20.1441 6.39088C20.0435 6.63368 19.896 6.85425 19.71 7.04L19.65 7.1C19.4195 7.33568 19.2648 7.63502 19.206 7.95941C19.1472 8.28381 19.1869 8.61838 19.32 8.92V9C19.4468 9.29577 19.6572 9.54802 19.9255 9.72569C20.1938 9.90337 20.5082 9.99872 20.83 10H21C21.5304 10 22.0391 10.2107 22.4142 10.5858C22.7893 10.9609 23 11.4696 23 12C23 12.5304 22.7893 13.0391 22.4142 13.4142C22.0391 13.7893 21.5304 14 21 14H20.91C20.5882 14.0013 20.2738 14.0966 20.0055 14.2743C19.7372 14.452 19.5268 14.7042 19.4 15Z" stroke="#103C6E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const ChevronDownIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="6 9 12 15 18 9"></polyline>
    </svg>
);

/**
 * Add/edit form for one formula **or** one enteral additive.
 *
 * `type === 'additive'` switches it into additive mode: the feed-type selector,
 * the two per-meal/continuous checkboxes and the sachet/mg units are all
 * meaningless for something dosed as a percentage, so they are replaced by a
 * single "אחוז ברירת מחדל" field. Everything else — the nutrient table, the
 * dynamic rows, the validation — is shared, because an additive's nutrients are
 * stored exactly like a formula's, just per gram or per ml instead of per feed.
 */
const AddEditFormula = ({ formula, type, onSave, onCancel, isSubmitting, availableKeys = [], availableNutritions = [] }) => {
    const isAdditive = type === 'additive';
    const [formData, setFormData] = useState({
        name: '',
        instructions: '',
        per: 'ml',
        per_meals_calculation: true,
        allow_continuous_feeding: false,
        glucose: 0,
        protein: 0,
        fat: 0,
        calories: 0,
        sodium: 0,
        potassium: 0,
        calcium: 0,
        phosphorus: 0,
        magnesium: 0,
    });

    const [errors, setErrors] = useState({});
    const [editingRows, setEditingRows] = useState([]);
    const [dynamicNutrients, setDynamicNutrients] = useState([]);
    const [selectedType, setSelectedType] = useState(type);
    const [initialType, setInitialType] = useState(type); // Track the initial type
    const [visibleNutrients, setVisibleNutrients] = useState(new Set()); // Track which nutrients should be visible

    useEffect(() => {
        if (formula) {
            setFormData({ ...formula });
            // Set visible nutrients based on formula data
            const visible = new Set();
            Object.keys(formula).forEach(key => {
                if (formula[key] !== undefined && formula[key] !== 0 && isNutrientKey(key)) {
                    visible.add(key);
                }
            });
            setVisibleNutrients(visible);
        } else {
            setFormData({
                name: '',
                instructions: '',
                per: isAdditive ? 'gram' : 'ml',
                // Additives carry no meals/continuous semantics; the calculator
                // derives their amount from the base feed's volume instead.
                ...(isAdditive ? { defaultPercent: '' } : { per_meals_calculation: true }),
                glucose: 0,
                protein: 0,
                fat: 0,
                calories: 0,
                sodium: 0,
                potassium: 0,
                calcium: 0,
                phosphorus: 0,
                magnesium: 0,
            });
            setVisibleNutrients(new Set());
        }
        // Set the initial type and selected type only when formula changes
        setInitialType(type);
        setSelectedType(type);
        setErrors({});
        setEditingRows([]);
    }, [formula]);

    const handleChange = (name, value) => {
        let processedValue = value;
        if (isNutrientKey(name)) {
            // For numeric fields, keep the raw string value to allow typing "0." or "0.25"
            // Only keep as string to preserve input state
            processedValue = value;
        }

        setFormData(prev => {
            const updated = {
                ...prev,
                [name]: processedValue
            };
            return updated;
        });

        // Clear error for this field
        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: false }));
        }
        // Typing any nutrient value may satisfy the "at least one" rule.
        if (errors.noNutrients && isNutrientKey(name)) {
            setErrors(prev => ({ ...prev, noNutrients: false }));
        }
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formData.name || formData.name.trim() === '') {
            newErrors.name = true;
        }

        if (isAdditive) {
            const percent = parseFloat(String(formData.defaultPercent ?? '').trim());
            if (!isFinite(percent) || percent <= 0) {
                newErrors.defaultPercent = true;
            }

            // An additive with no nutrient values is worse than useless: the
            // calculator shows an amount for it ("8 גרם ליום") while it adds
            // nothing at all to the totals, which reads as a broken calculator
            // rather than as missing configuration. Refuse to save that state.
            const hasAnyNutrient =
                Array.from(visibleNutrients).some(key => parseFloat(String(formData[key])) > 0) ||
                dynamicNutrients.some(row => row.name && parseFloat(String(row.value)) > 0);
            if (!hasAnyNutrient) {
                newErrors.noNutrients = true;
            }
        }

        // Validate visible nutrients have values
        visibleNutrients.forEach(key => {
            const value = formData[key];
            const stringValue = String(value).trim();
            // Consider invalid if: empty string, undefined, null, or not a valid number
            // Note: "0" and "0.0" are valid values
            if (value === undefined || value === null || stringValue === '' || isNaN(parseFloat(stringValue))) {
                newErrors[key] = true;
            }
        });

        dynamicNutrients.forEach(row => {
            if (!row.name) {
                newErrors[`${row.id}_name`] = true;
            }
            if (!row.value || String(row.value).trim() === '') {
                newErrors[`${row.id}_value`] = true;
            }
        });

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = () => {
        if (validateForm()) {
            // Merge dynamic nutrients into formData and convert all numeric fields to numbers
            const updatedFormData = { ...formData };

            // Convert all numeric fields to actual numbers
            Object.keys(updatedFormData).forEach(key => {
                if (isNutrientKey(key)) {
                    const value = updatedFormData[key];
                    updatedFormData[key] = typeof value === 'string' ? (parseFloat(value) || 0) : value;
                }
            });

            // `defaultPercent` is reserved (so it never becomes a nutrient row) but
            // is still numeric, so it needs coercing on its own.
            if (isAdditive) {
                updatedFormData.defaultPercent = parseFloat(updatedFormData.defaultPercent) || 0;
            }

            dynamicNutrients.forEach(nutrient => {
                if (nutrient.name && nutrient.value) {
                    updatedFormData[nutrient.name] = parseFloat(nutrient.value) || 0;
                }
            });

            // Note: The type (selectedType) is managed by the parent component
            // It's passed as a prop and should be handled separately if needed
            // For now, we're just saving the nutrition data

            onSave(updatedFormData, selectedType);
        }
    };

    // Generate nutrients list from availableNutritions
    const nutrients = React.useMemo(() => {
        return availableNutritions.map(nutrition => ({
            key: nutrition.englishName.toLowerCase(),
            label: nutrition.hebrewName,
            unit: nutrition.unit,
            mandatory: false
        }));
    }, [availableNutritions]);

    // Helper function to get unit for a nutrient key
    const getUnitForKey = (key) => {
        const nutrient = availableNutritions.find(n => n.englishName.toLowerCase() === key);
        return nutrient ? nutrient.unit : '';
    };

    // Generate nutrition options from availableNutritions
    const availableNutritionOptions = React.useMemo(() => {
        return availableNutritions.map(nutrition => ({
            value: nutrition.englishName.toLowerCase(),
            label: `${nutrition.hebrewName} (${nutrition.unit})`
        }));
    }, [availableNutritions]);

    // Combine generated options with availableKeys from parent
    const allOptions = React.useMemo(() => {
        const options = [...availableNutritionOptions];
        if (availableKeys) {
            availableKeys.forEach(key => {
                if (!options.some(opt => opt.value === key)) {
                    options.push({ value: key, label: key });
                }
            });
        }
        return options;
    }, [availableNutritionOptions, availableKeys]);

    const handleAddRow = () => {
        const newRow = {
            id: `new_${Date.now()}`,
            name: '',
            value: ''
        };
        setDynamicNutrients([...dynamicNutrients, newRow]);
        setEditingRows([...editingRows, newRow.id]);
    };

    const handleDeleteDynamicRow = (id) => {
        setDynamicNutrients(dynamicNutrients.filter(n => n.id !== id));
        setEditingRows(editingRows.filter(k => k !== id));
    };

    const handleUpdateDynamicRow = (id, field, value) => {
        setDynamicNutrients(dynamicNutrients.map(n =>
            n.id === id ? { ...n, [field]: value } : n
        ));

        // Clear error
        const errorKey = `${id}_${field}`;
        if (errors[errorKey]) {
            setErrors(prev => ({ ...prev, [errorKey]: false }));
        }
        if (errors.noNutrients) {
            setErrors(prev => ({ ...prev, noNutrients: false }));
        }
    };

    const toggleEditRow = (key) => {
        if (editingRows.includes(key)) {
            setEditingRows(editingRows.filter(k => k !== key));
        } else {
            setEditingRows([...editingRows, key]);
        }
    };

    const confirmRowEdit = (key) => {
        setEditingRows(editingRows.filter(k => k !== key));
    };

    return (
        <div className="add-edit-formula-container">
            {/* Header Section */}
            <div className="form-header-section">
                <div style={{ marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <div style={{ fontSize: '0.9em', fontWeight: 'bold', color: '#103C6E', whiteSpace: 'nowrap', minWidth: '90px' }}>{isAdditive ? 'שם התוסף:' : 'שם הפורמולה:'}</div>
                    <input
                        type="text"
                        value={formData.name}
                        onChange={(e) => handleChange('name', e.target.value)}
                        placeholder={isAdditive ? 'הכנס שם תוסף' : 'הכנס שם פורמולה'}
                        className="formula-name-input"
                        style={{
                            width: '250px',
                            border: '1px solid #ddd',
                            borderRadius: '8px',
                            padding: '8px 12px',
                            fontSize: '0.95rem',
                            outline: 'none',
                            backgroundColor: 'white'
                        }}
                    />
                </div>
                {errors.name && (
                    <div className="error-message">
                        <span>{isAdditive ? 'יש למלא את שם התוסף' : 'יש למלא את שם הפורמולה'}</span>
                    </div>
                )}
                {!isAdditive && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px', justifyContent: 'flex-start' }}>
                        <div style={{ fontSize: '0.9em', fontWeight: 'bold', color: '#103C6E', minWidth: '90px' }}>סוג הזנה:</div>
                        <Select
                            value={selectedType === 'TPN' ? 'TPN' : 'enteral'}
                            onChange={(e) => {
                                setSelectedType(e.target.value);
                            }}
                            size="small"
                            sx={{
                                borderRadius: '8px',
                                backgroundColor: 'white',
                                textAlign: 'right',
                                width: '250px',
                                '& .MuiSelect-icon': {
                                    left: '7px',
                                    right: 'auto'
                                }
                            }}
                        >
                            <MenuItem value="TPN">TPN</MenuItem>
                            <MenuItem value="enteral">אנטרלית</MenuItem>
                        </Select>
                    </div>
                )}
                {isAdditive && (
                    <>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px', justifyContent: 'flex-start' }}>
                            <div style={{ fontSize: '0.9em', fontWeight: 'bold', color: '#103C6E', minWidth: '90px' }}>יחידת מדידה:</div>
                            <Select
                                value={formData.per === 'ml' ? 'ml' : 'gram'}
                                onChange={(e) => handleChange('per', e.target.value)}
                                size="small"
                                sx={{
                                    borderRadius: '8px',
                                    backgroundColor: 'white',
                                    textAlign: 'right',
                                    width: '250px',
                                    '& .MuiSelect-icon': { left: '7px', right: 'auto' }
                                }}
                            >
                                <MenuItem value="gram">גרם (אבקה)</MenuItem>
                                <MenuItem value="ml">מ&quot;ל (נוזל / שמן)</MenuItem>
                            </Select>
                        </div>
                        <div style={{ fontSize: '0.8em', color: '#666', marginBottom: '20px', lineHeight: '1.5' }}>
                            יחידת המידה קובעת את משמעות האחוז: <strong>גרם</strong> — כך ש-2% הם 2 גרם אבקה לכל 100 מ&quot;ל הזנה,
                            ו<strong>מ&quot;ל</strong> — כך ש-3% הם 3 מ&quot;ל לכל 100 מ&quot;ל הזנה.
                            <br />
                            הערכים התזונתיים בטבלה למטה מוזנים <strong>ליחידה אחת</strong> (לגרם או למ&quot;ל).
                            <br />
                            תוסף במ&quot;ל מוסיף גם לנפח הנוזלים היומי; תוסף בגרם לא.
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '6px', justifyContent: 'flex-start' }}>
                            <div style={{ fontSize: '0.9em', fontWeight: 'bold', color: '#103C6E', minWidth: '90px' }}>אחוז ברירת מחדל:</div>
                            <input
                                type="number"
                                min="0"
                                step="0.1"
                                value={formData.defaultPercent ?? ''}
                                onChange={(e) => handleChange('defaultPercent', e.target.value)}
                                placeholder="%"
                                className="formula-name-input"
                                style={{
                                    width: '120px',
                                    border: errors.defaultPercent ? '1px solid #d32f2f' : '1px solid #ddd',
                                    borderRadius: '8px',
                                    padding: '8px 12px',
                                    fontSize: '0.95rem',
                                    outline: 'none',
                                    backgroundColor: 'white'
                                }}
                            />
                        </div>
                        {errors.defaultPercent && (
                            <div className="error-message">
                                <span>יש להזין אחוז ברירת מחדל גדול מאפס</span>
                            </div>
                        )}
                        <div style={{ fontSize: '0.8em', color: '#666', marginTop: '6px', marginBottom: '20px', lineHeight: '1.5' }}>
                            האחוז שיוצג במחשבון כשבוחרים את התוסף. זו <strong>ברירת מחדל בלבד</strong> — ניתן לשנות אותה במחשבון לכל ערך אחר.
                        </div>
                    </>
                )}
                {!isAdditive && selectedType !== 'TPN' && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px', justifyContent: 'flex-start' }}>
                        <div style={{ fontSize: '0.9em', fontWeight: 'bold', color: '#103C6E', minWidth: '90px' }}>יחידת מדידה:</div>
                        <Select
                            value={formData.per || 'ml'}
                            onChange={(e) => handleChange('per', e.target.value)}
                            size="small"
                            sx={{
                                borderRadius: '8px',
                                backgroundColor: 'white',
                                textAlign: 'right',
                                width: '250px',
                                '& .MuiSelect-icon': {
                                    left: '7px',
                                    right: 'auto'
                                }
                            }}
                        >
                            <MenuItem value="ml">מ"ל (ml)</MenuItem>
                            <MenuItem value="sachet">שקית (sachet)</MenuItem>
                            <MenuItem value="gram">גרם (gram)</MenuItem>
                            <MenuItem value="mg">מ"ג (mg)</MenuItem>
                        </Select>
                    </div>
                )}
                {!isAdditive && selectedType !== 'TPN' && (
                    <div style={{ marginBottom: '20px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', justifyContent: 'flex-start' }}>
                            <input
                                type="checkbox"
                                id="per_meals_calculation"
                                checked={formData.per_meals_calculation ?? (formData.per === 'ml')}
                                onChange={(e) => handleChange('per_meals_calculation', e.target.checked)}
                                style={{ width: '18px', height: '18px', cursor: 'pointer' }}
                            />
                            <label htmlFor="per_meals_calculation" style={{ fontSize: '0.9em', fontWeight: 'bold', color: '#103C6E', cursor: 'pointer' }}>
                                חישוב לפי כמות ארוחות
                            </label>
                        </div>
                        <div style={{ fontSize: '0.8em', color: '#666', marginTop: '6px', lineHeight: '1.5' }}>
                            כשמסומן: הערך שמוזן במחשבון הוא <strong>לארוחה אחת</strong> ומוכפל במספר הארוחות ביום.
                            <br />
                            כשלא מסומן: הערך שמוזן במחשבון הוא <strong>הסכום היומי הכולל</strong> ונלקח כמו שהוא.
                        </div>
                    </div>
                )}
                {!isAdditive && selectedType !== 'TPN' && (
                    <div style={{ marginBottom: '20px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', justifyContent: 'flex-start' }}>
                            <input
                                type="checkbox"
                                id="allow_continuous_feeding"
                                checked={formData.allow_continuous_feeding ?? false}
                                onChange={(e) => handleChange('allow_continuous_feeding', e.target.checked)}
                                style={{ width: '18px', height: '18px', cursor: 'pointer' }}
                            />
                            <label htmlFor="allow_continuous_feeding" style={{ fontSize: '0.9em', fontWeight: 'bold', color: '#103C6E', cursor: 'pointer' }}>
                                אפשר הזנה רציפה
                            </label>
                        </div>
                        <div style={{ fontSize: '0.8em', color: '#666', marginTop: '6px', lineHeight: '1.5' }}>
                            כשמסומן: במחשבון תופיע אפשרות <strong>"הזנה רציפה"</strong> לפורמולה זו. כשהיא נבחרת, במקום כמות ומספר ארוחות מוזנים <strong>קצב לשעה</strong> ו<strong>משך מתן (בשעות)</strong> (ברירת מחדל 24), כמו ב-TPN.
                        </div>
                    </div>
                )}
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', marginBottom: '20px', justifyContent: 'flex-start' }}>
                    <div style={{ fontSize: '0.9em', fontWeight: 'bold', color: '#103C6E', minWidth: '90px', paddingTop: '8px' }}>פירוט:</div>
                    <textarea
                        value={formData.instructions || ''}
                        onChange={(e) => handleChange('instructions', e.target.value)}
                        placeholder="פירוט (אופציונלי)"
                        style={{                            
                            width: '100%',
                            minHeight: '60px',
                            border: '1px solid #ddd',
                            borderRadius: '8px',
                            padding: '8px 12px',
                            fontSize: '0.95rem',
                            outline: 'none',
                            backgroundColor: 'white',
                            resize: 'vertical',
                            fontFamily: 'inherit'
                        }}
                    />
                </div>
            </div>

            {/* Nutrients Table */}
            <div className="nutrients-table-container">
                {isAdditive && (
                    <div style={{ fontSize: '0.85em', color: '#666', marginBottom: '10px', lineHeight: '1.5', textAlign: 'right' }}>
                        יש להזין כאן לפחות ערך תזונתי אחד, <strong>ליחידה אחת</strong> של התוסף
                        ({formData.per === 'ml' ? 'למ&quot;ל' : 'לגרם'}) — למשל 4 קלוריות לגרם.
                        בלעדיהם התוסף יוצג במחשבון אך לא ישפיע על סיכום ההזנה.
                        השתמשו בכפתור <strong>+ הוספת ערך</strong> שבתחתית הטופס.
                    </div>
                )}
                {errors.noNutrients && (
                    <div className="error-message">
                        <span>יש להזין לפחות ערך תזונתי אחד לתוסף</span>
                    </div>
                )}
                <div className="nutrients-header">
                    <div className="header-cell right">ערך תזונתי</div>
                    <div className="header-cell center">כמות</div>
                    <div className="header-cell actions"></div>
                </div>

                <div className="nutrients-body">
                    {nutrients
                        .filter(nutrient => visibleNutrients.has(nutrient.key))
                        .map((nutrient) => {
                            const isEditing = editingRows.includes(nutrient.key);
                            const hasError = errors[nutrient.key];
                            return (
                                <div key={nutrient.key} className="nutrient-row">
                                    <div className="row-label">{nutrient.label} ({nutrient.unit})</div>
                                    <div className="row-input" style={{ display: 'flex', flexDirection: 'column' }}>
                                        {isEditing ? (
                                            <>
                                                <input
                                                    type="number"
                                                    value={formData[nutrient.key] || ''}
                                                    onChange={(e) => handleChange(nutrient.key, e.target.value)}
                                                    placeholder={nutrient.unit}
                                                    className="nutrient-input"
                                                    style={hasError ? { borderColor: '#d32f2f' } : {}}
                                                />
                                                {hasError && (
                                                    <div style={{ color: '#d32f2f', fontSize: '0.75rem', marginTop: '3px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                        <span style={{ fontSize: '12px' }}></span> יש להזין ערך
                                                    </div>
                                                )}
                                            </>
                                        ) : (
                                            <span className="value-display" dir="ltr" style={{ textAlign: 'right' }}>{formData[nutrient.key]} {nutrient.unit}</span>
                                        )}
                                    </div>
                                    <div className="row-actions">
                                        {isEditing ? (
                                            <Button
                                                size="small"
                                                variant="contained"
                                                onClick={() => confirmRowEdit(nutrient.key)}
                                                sx={{
                                                    backgroundColor: '#103C6E',
                                                    color: 'white',
                                                    borderRadius: '6px',
                                                    padding: '4px 16px',
                                                    fontSize: '0.85rem',
                                                    minWidth: '60px',
                                                    '&:hover': { backgroundColor: '#0d2e54' }
                                                }}
                                            >
                                                אישור
                                            </Button>
                                        ) : (
                                            <>
                                                <IconButton
                                                    size="small"
                                                    onClick={() => toggleEditRow(nutrient.key)}
                                                    className="icon-button edit-button"
                                                >
                                                    <EditIconSvg />
                                                </IconButton>
                                                <IconButton
                                                    size="small"
                                                    onClick={() => {
                                                        handleChange(nutrient.key, 0);
                                                        setVisibleNutrients(prev => {
                                                            const newSet = new Set(prev);
                                                            newSet.delete(nutrient.key);
                                                            return newSet;
                                                        });
                                                    }}
                                                    className="icon-button delete-button"
                                                >
                                                    <DeleteIconSvg />
                                                </IconButton>
                                            </>
                                        )}
                                    </div>
                                </div>
                            );
                        })}

                    {/* Dynamic Nutrition Rows */}
                    {dynamicNutrients.map((nutrient) => {
                        const isEditing = editingRows.includes(nutrient.id);

                        // Calculate used keys to filter options
                        const activeStaticKeys = Array.from(visibleNutrients);

                        const usedDynamicKeys = dynamicNutrients
                            .filter(n => n.id !== nutrient.id && n.name)
                            .map(n => n.name);

                        const blockedKeys = new Set([...activeStaticKeys, ...usedDynamicKeys]);

                        const rowOptions = allOptions.filter(opt =>
                            opt.value === nutrient.name || !blockedKeys.has(opt.value)
                        );

                        // Get unit for this nutrient
                        const nutrientUnit = getUnitForKey(nutrient.name);

                        return (
                            <div key={nutrient.id} className="nutrient-row" style={{ alignItems: 'flex-start' }}>
                                <div className="row-label" style={{ display: 'flex', flexDirection: 'column' }}>
                                    {isEditing ? (
                                        <>
                                            <Autocomplete
                                                options={rowOptions}
                                                getOptionLabel={(option) => {
                                                    if (typeof option === 'string') return option;
                                                    return option.label;
                                                }}
                                                value={allOptions.find(opt => opt.value === nutrient.name) || null}
                                                onChange={(_event, newValue) => {
                                                    const val = newValue?.value || '';
                                                    handleUpdateDynamicRow(nutrient.id, 'name', val);
                                                }}
                                                popupIcon={<ChevronDownIcon />}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        size="small"
                                                        placeholder="בחר ערך תזונתי"
                                                        error={!!errors[`${nutrient.id}_name`]}
                                                        sx={{
                                                            '& .MuiOutlinedInput-root': {
                                                                borderRadius: '8px',
                                                                backgroundColor: 'white',
                                                                paddingLeft: '30px !important'
                                                            }
                                                        }}
                                                    />
                                                )}
                                                sx={{
                                                    minWidth: '180px',
                                                    '& .MuiAutocomplete-endAdornment': {
                                                        right: 'auto !important',
                                                        left: '9px !important',
                                                        position: 'absolute',
                                                        top: '50%',
                                                        cursor: 'pointer'
                                                    },
                                                    '& .MuiAutocomplete-popupIndicator': {
                                                        cursor: 'pointer'
                                                    }
                                                }}
                                            />
                                            {errors[`${nutrient.id}_name`] && (
                                                <div style={{ color: '#d32f2f', fontSize: '0.75rem', marginTop: '3px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                    <span style={{ fontSize: '12px' }}></span> יש לבחור שם
                                                </div>
                                            )}
                                        </>
                                    ) : (
                                        allOptions.find(opt => opt.value === nutrient.name)?.label || nutrient.name || 'בחר ערך תזונתי'
                                    )}
                                </div>
                                <div className="row-input" style={{ display: 'flex', flexDirection: 'column' }}>
                                    {isEditing ? (
                                        <>
                                            <input
                                                type="number"
                                                value={nutrient.value}
                                                onChange={(e) => handleUpdateDynamicRow(nutrient.id, 'value', e.target.value)}
                                                placeholder={nutrientUnit || 'ערך'}
                                                className="nutrient-input"
                                                style={errors[`${nutrient.id}_value`] ? { borderColor: '#d32f2f' } : {}}
                                            />
                                            {errors[`${nutrient.id}_value`] && (
                                                <div style={{ color: '#d32f2f', fontSize: '0.75rem', marginTop: '3px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                    <span style={{ fontSize: '12px' }}></span> יש להזין ערך
                                                </div>
                                            )}
                                        </>
                                    ) : (
                                        <span className="value-display" dir="ltr" style={{ textAlign: 'right' }}>{nutrient.value || 'ערך'} {nutrientUnit}</span>
                                    )}
                                </div>
                                <div className="row-actions">
                                    {isEditing ? (
                                        <Button
                                            size="small"
                                            variant="contained"
                                            onClick={() => confirmRowEdit(nutrient.id)}
                                            sx={{
                                                backgroundColor: '#103C6E',
                                                color: 'white',
                                                borderRadius: '6px',
                                                padding: '4px 16px',
                                                fontSize: '0.85rem',
                                                minWidth: '60px',
                                                '&:hover': { backgroundColor: '#0d2e54' }
                                            }}
                                        >
                                            אישור
                                        </Button>
                                    ) : (
                                        <>
                                            <IconButton
                                                size="small"
                                                onClick={() => toggleEditRow(nutrient.id)}
                                                className="icon-button edit-button"
                                            >
                                                <EditIconSvg />
                                            </IconButton>
                                            <IconButton
                                                size="small"
                                                onClick={() => handleDeleteDynamicRow(nutrient.id)}
                                                className="icon-button delete-button"
                                            >
                                                <DeleteIconSvg />
                                            </IconButton>
                                        </>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            {/* Footer Actions */}
            <div className="form-footer">
                <div className="left-actions">
                    <Button
                        onClick={handleSubmit}
                        variant="contained"
                        disabled={isSubmitting}
                        sx={{
                            backgroundColor: '#103C6E',
                            borderRadius: '8px',
                            padding: '8px 30px',
                            fontSize: '1rem',
                            fontWeight: 'bold',
                            '&:hover': { backgroundColor: '#0d2e54' },
                            '&:disabled': { backgroundColor: '#ccc' }
                        }}
                    >
                        {isSubmitting ? 'שומר...' : (formula ? 'שמירת שינויים' : 'הוספה')}
                    </Button>
                    <Button
                        onClick={onCancel}
                        variant="outlined"
                        sx={{
                            borderColor: '#103C6E',
                            color: '#103C6E',
                            borderRadius: '8px',
                            padding: '8px 30px',
                            fontSize: '1rem',
                            marginRight: '12px'
                        }}
                    >
                        בטל
                    </Button>
                </div>

                <div className="right-actions">
                    <Button
                        variant="outlined"
                        onClick={handleAddRow}
                        sx={{
                            borderColor: '#103C6E',
                            color: '#103C6E',
                            borderRadius: '8px',
                            padding: '8px 20px',
                        }}
                    >
                        + הוספת ערך
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default AddEditFormula;
